module.exports = __webpack_public_path__ + "static/media/Home.c9ef7ad2.png";